(function () {
	const initPopularArticlesFilter = () => {
		const sections = document.querySelectorAll('.popular-articles');
		
		sections.forEach((section, sectionIndex) => {
			const filterTags = section.querySelectorAll('.popular-articles__filter-tag');
			
			// Find the section slider - try multiple approaches
			let sectionSlider = null;
			
			// Try 1: Look for sibling .section-slider
			if (section.nextElementSibling && section.nextElementSibling.classList.contains('section-slider')) {
				sectionSlider = section.nextElementSibling;
			}
			// Try 2: Look in parent for .section-slider
			else if (section.parentElement) {
				sectionSlider = section.parentElement.querySelector('.section-slider');
			}
			// Try 3: Look for .section-slider that comes after this section
			else {
				let nextSibling = section.nextElementSibling;
				while (nextSibling && !sectionSlider) {
					if (nextSibling.classList && nextSibling.classList.contains('section-slider')) {
						sectionSlider = nextSibling;
						break;
					}
					nextSibling = nextSibling.nextElementSibling;
				}
			}
			
			// Find slides - they're inside .swiper which is inside .section-slider
			const swiperElement = sectionSlider ? sectionSlider.querySelector('.swiper') : null;
			
			// Find all swiper slides (they might not have data-article-tags yet)
			const allSlides = swiperElement ? swiperElement.querySelectorAll('.swiper-slide') : [];
			
			// Process slides to add data-article-tags if missing
			allSlides.forEach((slide) => {
				// Add the class if not present
				if (!slide.classList.contains('popular-articles__slide')) {
					slide.classList.add('popular-articles__slide');
				}
				
				// If data-article-tags is missing, try to extract from article card
				if (!slide.getAttribute('data-article-tags')) {
					const articleCard = slide.querySelector('article[aria-labelledby]');
					if (articleCard) {
						// Try to get tags from article card tag links
						const tagLinks = articleCard.querySelectorAll('.article-card__tags a[href*="/tagged/"]');
						const tags = [];
						tagLinks.forEach(tagLink => {
							// Extract tag handle from URL like /blogs/blog-name/tagged/tag-handle
							const href = tagLink.getAttribute('href');
							if (href) {
								const match = href.match(/\/tagged\/([^\/\?]+)/);
								if (match && match[1]) {
									tags.push(match[1]);
								}
							}
						});
						
						if (tags.length > 0) {
							const tagsString = tags.join(',') + ',';
							slide.setAttribute('data-article-tags', tagsString);
						}
					}
				}
			});
			
			// Find article slides - try swiper first, then fallback to direct query in section
			let articleSlides = swiperElement ? swiperElement.querySelectorAll('.popular-articles__slide') : [];
			
			// Fallback: if no swiper found, look for .popular-articles__slide directly in section (for list items)
			if (articleSlides.length === 0) {
				articleSlides = section.querySelectorAll('.popular-articles__slide');
			}
			
			let swiperInstance = null;
			
			// Get existing swiper instance if available
			// The swiper instance is stored on the .section-slider element
			if (sectionSlider && sectionSlider.swiperInstance) {
				swiperInstance = sectionSlider.swiperInstance;
			}
			
			if (filterTags.length === 0) {
				return;
			}
			
			// Check if "All" button already exists
			const existingAllButton = section.querySelector('.popular-articles__filter-tag[data-filter-tag="all"]');
			const categoriesContainer = section.querySelector('.popular-articles__categories');
			
			// Add active class to first filter tag (show all) if it doesn't exist
			if (!existingAllButton && categoriesContainer) {
				const showAllButton = document.createElement('button');
				showAllButton.type = 'button';
				showAllButton.className = 'badge popular-articles__category-tag popular-articles__filter-tag popular-articles__filter-tag--active';
				showAllButton.setAttribute('data-filter-tag', 'all');
				showAllButton.textContent = 'All';
				showAllButton.style.marginRight = '0.5rem';
				categoriesContainer.insertBefore(showAllButton, categoriesContainer.firstChild);
			}
			
			// Set "All" button as active by default if no filter tag is active
			const activeTag = section.querySelector('.popular-articles__filter-tag--active');
			const allButton = section.querySelector('.popular-articles__filter-tag[data-filter-tag="all"]');
			if (!activeTag && allButton) {
				allButton.classList.add('popular-articles__filter-tag--active');
			}
			
			// If "All" button exists and is active, ensure all slides are visible
			if (allButton && allButton.classList.contains('popular-articles__filter-tag--active')) {
				const swiperEl = sectionSlider ? sectionSlider.querySelector('.swiper') : null;
				let allSlides = swiperEl ? swiperEl.querySelectorAll('.popular-articles__slide') : [];
				// Fallback: if no swiper, look directly in section
				if (allSlides.length === 0) {
					allSlides = section.querySelectorAll('.popular-articles__slide');
				}
				allSlides.forEach((slide) => {
					slide.style.display = '';
					slide.classList.remove('popular-articles__slide--hidden');
				});
			}
			
			const allFilterTags = section.querySelectorAll('.popular-articles__filter-tag');
			
			allFilterTags.forEach((tag, tagIndex) => {
				// Remove existing listeners by cloning
				const newTag = tag.cloneNode(true);
				tag.parentNode.replaceChild(newTag, tag);
				
				newTag.addEventListener('click', function(e) {
					e.preventDefault();
					e.stopPropagation();
					
					const selectedTag = this.getAttribute('data-filter-tag');
					
					// Update active state
					const allTags = section.querySelectorAll('.popular-articles__filter-tag');
					allTags.forEach((t) => {
						t.classList.remove('popular-articles__filter-tag--active');
					});
					this.classList.add('popular-articles__filter-tag--active');
					
					// Filter articles - query again to get current slides from the swiper element
					const swiperEl = sectionSlider ? sectionSlider.querySelector('.swiper') : null;
					let currentSlides = swiperEl ? swiperEl.querySelectorAll('.popular-articles__slide') : [];
					
					// Fallback: if no slides found, try swiper-slide with data-article-tags
					if (currentSlides.length === 0 && swiperEl) {
						currentSlides = swiperEl.querySelectorAll('.swiper-slide[data-article-tags]');
						
						// If found with fallback, add the class for future queries
						if (currentSlides.length > 0) {
							currentSlides.forEach(slide => {
								slide.classList.add('popular-articles__slide');
							});
						}
					}
					
					// Fallback: if no swiper found, look for .popular-articles__slide directly in section (for list items)
					if (currentSlides.length === 0) {
						currentSlides = section.querySelectorAll('.popular-articles__slide');
					}
					
					currentSlides.forEach((slide) => {
						const articleTags = slide.getAttribute('data-article-tags') || '';
						
						if (selectedTag === 'all' || articleTags.includes(selectedTag + ',')) {
							slide.style.display = '';
							slide.classList.remove('popular-articles__slide--hidden');
						} else {
							slide.style.display = 'none';
							slide.classList.add('popular-articles__slide--hidden');
						}
					});
					
					// Update swiper if it exists
					if (swiperInstance) {
						setTimeout(() => {
							swiperInstance.update();
							swiperInstance.updateSlides();
							swiperInstance.updateSlidesClasses();
						}, 100);
					}
				});
			});
		});
	};
	
	document.addEventListener('DOMContentLoaded', function () {
		initPopularArticlesFilter();
	});
	
	document.addEventListener('shopify:section:load', function () {
		initPopularArticlesFilter();
	});
})();

